/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Generate_MagazineInputs */

const en_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate Magazine`)
};

const es_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar Revista`)
};

const fr_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer le Magazine`)
};

const de_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magazin generieren`)
};

const ja_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マガジンを生成`)
};

const zh_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成杂志`)
};

const ar_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء المجلة`)
};

const id_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Majalah`)
};

const it_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera Rivista`)
};

const ru_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать Журнал`)
};

const pt_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar Revista`)
};

const ko_generate_magazine = /** @type {(inputs: Generate_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잡지 생성`)
};

/**
* | output |
* | --- |
* | "Generate Magazine" |
*
* @param {Generate_MagazineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const generate_magazine = /** @type {((inputs?: Generate_MagazineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Generate_MagazineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_generate_magazine(inputs)
	if (locale === "es") return es_generate_magazine(inputs)
	if (locale === "fr") return fr_generate_magazine(inputs)
	if (locale === "de") return de_generate_magazine(inputs)
	if (locale === "ja") return ja_generate_magazine(inputs)
	if (locale === "zh") return zh_generate_magazine(inputs)
	if (locale === "ar") return ar_generate_magazine(inputs)
	if (locale === "id") return id_generate_magazine(inputs)
	if (locale === "it") return it_generate_magazine(inputs)
	if (locale === "ru") return ru_generate_magazine(inputs)
	if (locale === "pt") return pt_generate_magazine(inputs)
	return ko_generate_magazine(inputs)
});